import { parseIntent, readIntent, type PurchaseIntent } from './intent';

export function checkoutLoginOptions(
  intent: PurchaseIntent,
  method: 'google' | 'email' | 'login',
  switchAccount = false,
) {
  return {
    authorizationParams: {
      ui_locales: 'cs',
      ...(switchAccount ? { prompt: 'login' as const } : {}),
      ...(method === 'google' ? { connection: 'google-oauth2' } : {}),
      ...(method !== 'login' ? { screen_hint: 'signup' } : {}),
    },
    appState: { returnTo: '/checkout', ...intent },
  };
}
export function restoredIntent(appState?: Record<string, unknown>) {
  return parseIntent(appState) ?? (appState?.returnTo === '/checkout' ? readIntent() : null);
}
